import api from 'api';
import DesignSection from 'records/DesignSection';

export const DESIGN_SECTION_ASYNC_ACTION_START = 'DESIGN_SECTION_ASYNC_ACTION_START';
export const DESIGN_SECTION_ASYNC_ACTION_ERROR = 'DESIGN_SECTION_ASYNC_ACTION_ERROR';
export const DESIGN_SECTION_ASYNC_ACTION_SUCCESS = 'DESIGN_SECTION_ASYNC_ACTION_SUCCESS';
export const DESIGN_SECTION_UPDATE_ACTION_SUCCESS = 'DESIGN_SECTION_UPDATE_ACTION_SUCCESS';
export const DESIGN_SECTION_RESET_STATE = 'DESIGN_SECTION_RESET_STATE';


function designSectionAsyncActionStart() {
  return {
    type: DESIGN_SECTION_ASYNC_ACTION_START,
  };
}

function designSectionAsyncActionError(error) {
  return {
    type: DESIGN_SECTION_ASYNC_ACTION_ERROR,
    error,
  };
}

function designSectionAsyncUpdateSuccess(data) {
  return {
    type: DESIGN_SECTION_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function updateDesignSection(data) {
  return {
    type: DESIGN_SECTION_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function resetDesignSectionState() {
  return {
    type: DESIGN_SECTION_RESET_STATE,
  };
}

export function updateDesignSectionAsync(designSection,ifUpdateDesignItems) {
  let url='designsection';
  if(ifUpdateDesignItems==undefined){
    ifUpdateDesignItems=false;
  }
  if(ifUpdateDesignItems){
    url='designsection?updateDesignItems=true';
  }
  return (dispatch, getState) => {
    dispatch(designSectionAsyncActionStart());
    return api.request(url, 'put', designSection)
    .then((data) => {
      dispatch(designSectionAsyncUpdateSuccess(data));
      return new DesignSection(data);
    })
    .catch((err) => {
      dispatch(designSectionAsyncActionError('Unable to update design section'));
      throw (err);
    });
  };
}
